import * as React from "react";
import { t } from 'ttag';

export default class Hi extends React.Component {

    render() {
        return (
            <div style={{textAlign: 'center', marginTop: '20%'}}>
                <img style={{maxWidth: '150px', width: '100%'}} src="/cdn/images/target.svg"/>
                <h2>{t`Welkom, kies wat u wilt doen.`}</h2>
            </div>
        );
    }
}